import React from 'react';
import './Stats.css';

function Stats() {
  return (
    <section className="stats">
      <ul className="stats-list">
        <li className="stats-item">
          <span className="stats-value">10k+</span>
          <span className="stats-label">Transactions already made</span>
        </li>
        <li className="stats-item">
          <span className="stats-value">24/7</span>
          <span className="stats-label">Users support</span>
        </li>
        <li className="stats-item">
          <span className="stats-value">50+</span>
          <span className="stats-label">Countries</span>
        </li>
        <li className="stats-item">
          <span className="stats-value">$270K+</span>
          <span className="stats-label">Split with WeSplit</span>
        </li>
      </ul>
    </section>
  );
}

export default Stats; 